module.exports = __webpack_public_path__ + "img/54.d0d9e557.png";